<template>
	<label class="b-checkbox">
		<input
			type="checkbox"
			:disabled="disabled"
			:checked="isChecked"
			@change="handleChange"
		/>
		<div class="b-checkbox__checkbox" tabindex="0">
			<BIcon class="b-checkbox__icon" :name="icon" size="20px" />
		</div>
		<div class="b-checkbox__label" v-if="$slots.label || label">
			<template v-if="$slots.label">
				<slot name="label" />
			</template>
			<template v-else>
				{{ label }}
			</template>
		</div>
	</label>
</template>

<script>
import BIcon from "@/components/base/BIcon";

export default {
	name: "b-checkbox",
	components: {
		BIcon,
	},
	props: {
		value: {
			type: [Array, Boolean],
			default: () => [],
		},
		optionValue: {
			required: false,
			default: null,
		},
		label: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: String,
			default: "Checkmark",
		},
	},
	data() {
		return {};
	},
	computed: {
		classes() {
			return [];
		},
		isChecked() {
			if (Array.isArray(this.value)) {
				return this.value.includes(this.optionValue);
			} else {
				return this.value;
			}
		},
	},
	methods: {
		validateProps() {
			if (Array.isArray(this.value)) {
				if (this.optionValue === null) {
					console.error(
						"BCheckbox must have an :optionValue if value is an Array"
					);
				}
			}
		},
		handleChange(event) {
			if (this.disabled) {
				return;
			}

			let newValue;

			if (Array.isArray(this.value)) {
				newValue = event.target.checked
					? [...this.value, this.optionValue]
					: this.value.filter((item) => item !== this.optionValue);
			} else {
				newValue = !this.value;
			}

			this.$emit("input", newValue);
			this.$emit("change", newValue);
		},
	},
};
</script>

<style lang="scss">
.b-checkbox {
	display: flex;
	gap: 10px;
	cursor: pointer;

	input {
		display: none;
	}
}

.b-checkbox__checkbox {
	--size: 24px;
	width: var(--size);
	height: var(--size);
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid var(--color-neutral-600);
	flex-shrink: 0;
}

.b-checkbox__label {
	color: var(--color-neutral-600);
	font-size: var(--font-size-m);
	flex-grow: 1;
	margin-top: 0.14rem;
}

.b-checkbox__icon {
	display: none;
	color: var(--color-neutral-900);
}

.b-checkbox:has(:checked) {
	.b-checkbox__icon {
		display: block;
	}
}

.b-checkbox:not(:has(:disabled)) {
	.b-checkbox__icon {
		color: var(--color-neutral-900);
	}

	&:is(:hover, :has(:active)) {
		.b-checkbox__checkbox {
			border-color: var(--color-neutral-900);
		}
	}

	&:has(:focus, :active, :checked) {
		.b-checkbox__checkbox {
			background-color: var(--color-neutral-0);
		}
	}

	&:has(:focus) {
		.b-checkbox__checkbox {
		}
	}

	&:has(:checked, :active) {
		.b-checkbox__checkbox {
		}
	}

	&:has(:checked) {
		.b-checkbox__checkbox {
			border-color: var(--color-neutral-900);
		}
	}

	&:has(:active) {
		.b-checkbox__checkbox {
			border-color: var(--color-neutral-600);
		}
	}
}

.b-checkbox:has(:disabled) {
	cursor: not-allowed;

	.b-checkbox__checkbox {
		border-color: var(--color-neutral-150);
	}

	.b-checkbox__icon {
		color: var(--color-neutral-150);
	}

	.b-checkbox__label {
		color: var(--color-neutral-300);
	}

	&:has(:checked) {
		.b-checkbox__checkbox {
			background-color: var(--color-neutral-0);
		}
	}
}
</style>
